import axios from "~/plugins/axios";

export default {
  paginateUnprocessedGroupedByContractNumber(page = null) {
    return axios.get("/web_api/v1/afd_message/unprocessed/grouped_by_contract_number", {
      params: {
        page,
      },
    })
      .then((response) => response.data);
  },
  getUnprocessedByGroupedAfdMessage(afdMessageId) {
    return axios.get(`/web_api/v1/afd_message/unprocessed/by_grouped_message/${afdMessageId}`)
      .then((response) => response.data);
  },
  getDescriptionById(afdMessageId) {
    return axios.get(`/web_api/v1/afd_message/${afdMessageId}/description`)
      .then((response) => response.data);
  },
  getById(afdMessageId, includes = []) {
    return axios.get(`/web_api/v1/afd_message/${afdMessageId}`, { params: { include: includes } })
      .then((response) => response.data);
  },
  getByPolicyId(policyId) {
    return this.getByEntity("App\\Models\\Policy", policyId);
  },
  getByEntity(entityType, entityId) {
    return axios.post("/web_api/v1/afd_message/by_entity", {
      entity_type: entityType,
      entity_id: entityId,
    })
      .then((response) => response.data);
  },
};
